import React, {useState} from 'react';
import UserPanel from "../UserPanel/UserPanel";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SideMenu from "../SideMenu/SideMenu";

const NavigationHeaderMobile = (props) => {

    const [openSideMenu, setOpenSideMenu] = useState(false);

    return (
        <Box className="NavigationHeaderMobile" sx={{ flexGrow: 1 }}>
            <SideMenu open={openSideMenu} onClose={() => setOpenSideMenu(false)} />
            <AppBar className="appBar" position="static" sx={{ backgroundColor: 'transparent' }}>
                <Toolbar className="toolBar">
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        className="burgerIcon"
                        onClick={() => setOpenSideMenu(!openSideMenu)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <UserPanel />
                </Toolbar>
            </AppBar>
        </Box>
    );
}

export default NavigationHeaderMobile;
